export const REQUIRED = 'Required Field';
export const VALID_EMAIL = 'Must be a valid email';
export const VALID_PHONE = 'Must be a valid phone number. Ex: (999-999-9999)';
export const VALID_INTEGER = 'Must be a positive integer';
export const VALID_NUMBER = 'Must be a positive number';
export const VALID_ONE_PHOTO = 'Must have at least one photo';
export const CUSTOMER_QUESTIONS =
  'Please Answer All The Customer Comfort Survey Questions';
